<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="personAttributeAudits && personAttributeAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list (nextPage)="onNextPage()" [audits]="personAttributeAudits">
    </sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Person Attribute audits </ng-template>
</ng-template>
